"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Has12HourNotation = Has12HourNotation;

function Has12HourNotation() {
  // test to see if the browser has 12 or 24 notation.
  return new Date('7/10/2013 20:12:34').toLocaleTimeString().indexOf('20') !== 0;
}